import React from 'react';
import { get } from '../../../../../utils';
import { IconButton } from '../../../tw-components';
import CalendarIcon from '../../../../../images/calendar.svg';
import { useLDClient } from '@launchdarkly/react-sdk';

type Props = {
  children: React.ReactNode;
};

const CalendarContainer = (props: Props) => {
  return (
    <div
      className="tw-flex tw-items-baseline tw-justify-end tw-h-full tw-w-full 
                  tw-px-3 md:tw-px-0 tw-pt-3 md:tw-pb-5 "
    >
      {props.children}
    </div>
  );
};

const CardHeaderSection = (p: any) => {
  const ldClient = useLDClient();

  // Don't show calendar for ACM only cases. Must have a leave or claim.
  if (get(p, 'leaves', []).length === 0 && get(p, 'claims', []).length === 0) {
    return null;
  }

  return (
    <>
      {ldClient?.boolVariation('show-absence-history', true) &&
      get(p, 'leaves[0].absenceType', null) === 'Intermittent' ? (
        <CalendarContainer>
          <IconButton
            id="calendar-view-button-absence"
            to={`/app/absence-history/${p.NTNId}`}
          >
            <img
              src={CalendarIcon}
              className="tw-filter tw-invert tw-sepia tw-saturate-500 tw-hue-rotate-[180deg] tw-align-text-bottom tw-text-unm-interactive01-400"
              alt=""
              height="20px"
              width="18px"
            />{' '}
            Calendar
          </IconButton>
        </CalendarContainer>
      ) : (
        <CalendarContainer>
          <IconButton
            id="calendar-view-button-leave"
            to={`/app/leave-plan/${p.NTNId}`}
          >
            <img
              src={CalendarIcon}
              className="tw-filter tw-invert tw-sepia tw-saturate-500 tw-hue-rotate-[180deg] tw-align-text-bottom tw-text-unm-interactive01-400"
              alt=""
              height="20px"
              width="18px"
            />{' '}
            Calendar
          </IconButton>
        </CalendarContainer>
        // )
      )}
    </>
  );
};

export default CardHeaderSection;
